import { DurationType } from "@ternary/api-lib/analytics/enums";
import { DateRange } from "@ternary/api-lib/analytics/utils";
import { formatDate } from "date-fns";
import React, { useState } from "react";
import CustomDatePickerContent from "../../../../ui-lib/components/DateRangeControls/CustomDatePickerContent";
import { CustomSelectInput } from "../../../../ui-lib/components/DateRangeControls/CustomSelectInput";
import getMergeState from "../../../../utils/getMergeState";

type State = {
  endDate: string | null;
  invoiceMonth: string | null;
  isCustomDropdownOpen: boolean;
  isInvoiceMonth: boolean;
  startDate: string | null;
  tab: string;
};

const initialState = {
  endDate: null,
  invoiceMonth: null,
  isCustomDropdownOpen: false,
  isInvoiceMonth: true,
  startDate: null,
  tab: "invoice",
};

interface Props {
  endDate?: Date | null;
  invoiceMonth?: Date | null;
  showInvoice?: boolean;
  startDate?: Date | null;
  useCustomContent?: boolean;
  onChangeDateRange: (dateRange: DateRange, isInvoiceMonth: boolean) => void;
}

export function DatePickerWithSelect(props: Props) {
  const [state, setState] = useState<State>(initialState);
  const mergeState = getMergeState(setState);

  let dateRange: Date[] = [];
  let value: string | undefined = undefined;

  if (props.invoiceMonth) {
    dateRange = [props.invoiceMonth, props.invoiceMonth];
    value = formatDate(props.invoiceMonth, "MM-yyyy");
  } else if (props.startDate && props.endDate) {
    dateRange = [props.startDate, props.endDate];
    value = `${formatDate(props.startDate, "MM-dd-yyyy")} - ${formatDate(props.endDate, "MM-dd-yyyy")}`;
  }

  return (
    <CustomDatePickerContent
      dateRange={dateRange}
      durationType={DurationType.INVOICE}
      isOpen={state.isCustomDropdownOpen}
      showInvoice={props.showInvoice}
      singleMonthInvoice
      onChangeDateRange={props.onChangeDateRange}
      onClose={() =>
        mergeState({ isInvoiceMonth: true, isCustomDropdownOpen: false })
      }
      onOpen={() => mergeState({ isCustomDropdownOpen: true })}
    >
      <CustomSelectInput value={value} />
    </CustomDatePickerContent>
  );
}
